@if(field(); as field)
{
<div class="input-group" style="flex-wrap: nowrap;">
	<span class="input-group-text">
		@if(field.saving()){<i class="fa-fw fa-regular fa-spin fa-spinner-third"></i>}
		@else if(errorToShow() !== ''){<i class="fa-fw fa-solid fa-circle-xmark color-darkred"></i>}
		@else{<i class="fa-fw fa-regular fa-list-check"></i>}
	</span>
	<div class="multiselect">
		<label class="color-gray d-flex pb-2">
			{{field.config().label}}{{!field.config().isRequired ? ' ' + labels().optionalWithParentheses():''}}
		</label>
		@if(field.config().emptyOptionText && field.config().options.length === 0){
		<small class="d-inline-block" style="cursor: default;">
			{{field.config().emptyOptionText}}
		</small>
		}
		@for(option of field.config().options; track option.value;)
		{
		<div class="form-check pb-2" style="width: 100%;">
			<input class="form-check-input fs-6" type="checkbox"
				name="field-checkbox-{{field.config().label}}-{{option.value}}"
				id="{{field.config().label}}-{{option.value}}" [ngModel]="renderValue(option.value)"
				(ngModelChange)="onChange(option.value,$event)" (blur)='onBlur()' (focus)="onFocus()"
				[disabled]="option.disabled || field.saving() || !isEnabled()">
			<label class="form-check-label fs-6" for="{{field.config().label}}-{{option.value}}">
				{{option.text}}
				@if(option.subText){
				<small class="d-inline-block">{{option.subText}}</small>
				}
			</label>

		</div>
		}
	</div>
</div>

@if(errorToShow() !== '')
{
<div class="color-darkred text-end">{{errorToShow()}}</div>
}
}